import {
    FormatBoldRounded,
    FormatItalicRounded,
    FormatUnderlinedRounded,
} from '@mui/icons-material';
import AttrField from './AttrField';
import ButtonField from './ButtonField';

const nameSuffixes = {
    camel: {
        fontWeight: 'fontWeight',
        fontStyle: 'fontStyle',
        textDecoration: 'textDecoration',
    },
    kebab: {
        fontWeight: 'font-weight',
        fontStyle: 'font-style',
        textDecoration: 'text-decoration',
    },
};

const FormatButtons = ({ property, nameCase = 'camel' }) => {
    const idHeaing = property.includes('heading');
    const isLink = property.includes('link');

    return (
        <span>
            <AttrField
                Component={ButtonField}
                name={nameSuffixes[nameCase].fontWeight}
                property={property}
                exclusive
                reverseSelected={idHeaing}
                options={[
                    {
                        label: <FormatBoldRounded />,
                        value: idHeaing ? 'normal' : 'bold',
                    },
                ]}
            />
            <AttrField
                Component={ButtonField}
                name={nameSuffixes[nameCase].fontStyle}
                property={property}
                exclusive
                options={[{ label: <FormatItalicRounded />, value: 'italic' }]}
            />
            <AttrField
                Component={ButtonField}
                name={nameSuffixes[nameCase].textDecoration}
                property={property}
                exclusive
                reverseSelected={isLink}
                options={[
                    {
                        label: <FormatUnderlinedRounded />,
                        value: isLink ? 'none' : 'underline',
                    },
                ]}
            />
        </span>
    );
};

export default FormatButtons;
